export default __webpack_public_path__ + "static/media/H1018.4.51bf186d.mp3";